export const features = [
  {
    name: 'AI Create',
    href: '/feature/create/',
    icon: 'features/ai-create.svg',
    description: 'Build sites with our guided workflow'
  },
  {
    name: 'AI Agent Friendly',
    href: '/feature/agent-friendly/',
    icon: 'features/agent-friendly.svg',
    description: 'Publish from your AI agents'
  },
  {
    name: 'Feedback Mode',
    href: '/feature/feedback-mode/',
    icon: 'features/feedback-mode.svg',
    description: 'Collect comments on your pages'
  },
  {
    name: 'Document Collections',
    href: '/feature/document-collections/',
    icon: 'features/document-collections.svg',
    description: 'Share many files in one link'
  },
  {
    name: 'Shared Projects',
    href: '/feature/shared-projects/',
    icon: 'features/shared-projects.svg',
    description: 'Work together with your team'
  },
  {
    name: 'Password Protection',
    href: '/feature/password-protection/',
    icon: 'features/password-protection.svg',
    description: 'Keep your content private'
  },
  {
    name: 'Email Capture',
    href: '/feature/email-capture/',
    icon: 'features/email-capture.svg',
    description: 'Gate content behind an email'
  },
  {
    name: 'Advanced Analytics',
    href: '/feature/advanced-analytics/',
    icon: 'features/advanced-analytics.svg',
    description: 'See who views your content'
  },
  {
    name: 'Online Editor',
    href: '/feature/online-editor/',
    icon: 'features/online-editor.svg',
    description: 'Edit files in your browser'
  },
  {
    name: 'QR Codes',
    href: '/feature/qr-codes/',
    icon: 'features/qr-codes.svg',
    description: 'Share links with a scan'
  }
]

export const useCases = [
  { name: 'Sales', href: '/for/sales/', icon: 'for/sales.svg', description: 'Share proposals and track opens' },
  {
    name: 'Recruitment',
    href: '/for/recruitment/',
    icon: 'for/recruitment.svg',
    description: 'Send job packs and portfolios'
  },
  {
    name: 'Product Managers',
    href: '/for/product-managers/',
    icon: 'for/product-managers.svg',
    description: 'Share prototypes and specs'
  },
  {
    name: 'Marketing',
    href: '/for/marketing/',
    icon: 'for/marketing.svg',
    description: 'Launch campaigns and landing pages'
  },
  {
    name: 'Hospitality',
    href: '/for/hospitality/',
    icon: 'for/hospitality.svg',
    description: 'Menus and guides via QR code'
  },
  {
    name: 'E-learning',
    href: '/for/e-learning/',
    icon: 'for/e-learning.svg',
    description: 'Host courses and learning material'
  },
  {
    name: 'Developers',
    href: '/for/developers/',
    icon: 'for/developers.svg',
    description: 'Deploy sites from the CLI or API'
  }
]
